// Only foreground lazy imports block background route warming. Backend requests
// and background imports deliberately do not register, so slow data cannot
// prevent other page shells from loading.
let pending = 0
const listeners = new Set()

export const isPageLoading = () => pending > 0
export const subscribePageLoad = listener => {
    listeners.add(listener)
    return () => listeners.delete(listener)
}

export function beginPageLoad() {
    pending += 1
    listeners.forEach(listener => listener())
    let finished = false
    return () => {
        if (finished) return
        finished = true
        pending -= 1
        listeners.forEach(listener => listener())
    }
}
